import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { UpdatePaymentMethodParams, updatePaymentMethod } from '@utils/backend-api/stripe';

const usePaymentMethodUpdate = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: UpdatePaymentMethodParams) => updatePaymentMethod(params),
    {
      onSuccess: () => {
        toast.success('Payment method has been updated');
      },
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default usePaymentMethodUpdate;
